import "./AddBoard.scss";
import { useState } from "react";
import PropTypes from "prop-types";

const BOARD_ICONS = [
  "task_alt",
  "checklist",
  "dashboard",
  "view_kanban",
  "analytics",
  "campaign",
  "groups",
  "shopping_cart",
  "inventory_2",
  "rocket_launch",
  "emoji_objects",
  "psychology",
];

function AddBoard({ createBoard, cancelCreateBoard, existingBoard }) {
  const [name, setName] = useState(existingBoard?.name || "");
  const [selectedIcon, setSelectedIcon] = useState(
    existingBoard?.icon || "task_alt",
  );

  const handleSubmit = () => {
    if (name.trim()) {
      createBoard(name.trim(), selectedIcon);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && name.trim()) {
      handleSubmit();
    }
  };

  return (
    <div className="add-board-modal">
      <h3>{existingBoard ? "Edit Board" : "Create New Board"}</h3>

      <div className="form-group">
        <label>Board Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="e.g., Tasks, CRM, Marketing"
          autoFocus
          maxLength={50}
        />
      </div>

      <div className="form-group">
        <label>Icon</label>
        <div className="icon-selector">
          {BOARD_ICONS.map((icon) => (
            <div
              key={icon}
              className={`icon-option ${selectedIcon === icon ? "selected" : ""}`}
              onClick={() => setSelectedIcon(icon)}
            >
              <span className="material-symbols-outlined">{icon}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="button-group">
        <button className="cancel-button" onClick={cancelCreateBoard}>
          Cancel
        </button>
        <button
          className="create-button"
          onClick={handleSubmit}
          disabled={!name.trim()}
        >
          {existingBoard ? "Save" : "Create"}
        </button>
      </div>
    </div>
  );
}

AddBoard.propTypes = {
  createBoard: PropTypes.func.isRequired,
  cancelCreateBoard: PropTypes.func.isRequired,
  existingBoard: PropTypes.object,
};

AddBoard.defaultProps = {
  existingBoard: null,
};

export default AddBoard;
